import DataExtractionService from '../../dataExtraction/DataExtractionService';
import UrlService from '../../UrlService';

import { createCRMMessageHandler } from './crmMessageHandler';

export const salesforceMessageHandler = createCRMMessageHandler({
  isCompanyPage: UrlService.isSalesforceAccountPage,
  isContactPage: UrlService.isSalesforceContactPage,
  isLeadPage: UrlService.isSalesforceLeadPage,
  extractionService: DataExtractionService.salesforce,
});
